<template>
	<div class="details">
		<Commshop
		 :proData="transmitData"
		  />
		
		<div class="conten_body">  
			<div class="conten_left">
				
            
         <!-- 为什么选择万方？万方有什么优势？ -->
				<div class="con_list">
					<img class="" src="@/assets/images/testing/5-1/A58-20190408_01.jpg">
					<img class="" src="@/assets/images/testing/5-1/A57-20190408_02.jpg">
					<img class="" src="@/assets/images/testing/5-1/A57-20190408_03.jpg">
					<img class="" src="@/assets/images/testing/5-1/A57-20190408_04.jpg">
					<img class="" src="@/assets/images/testing/5-1/A57-20190408_05.jpg">
					<img class="" src="@/assets/images/testing/5-1/A57-20190408_06(1).png">
					
					
				</div>
				
				
			</div>
			<!-- right -->
			<Phone/>
			

		</div>
	</div>
</template>

<script type="text/javascript">
import Phone from "@/components/Phone.vue"
import Commshop from "@/components/Commshop.vue"
export default{
	components:{
      Phone,
      Commshop
	},
data(){
	return{
		transmitData:{
			title:"基线扫描及配置核查",
			content:"针对Web应用或网站的基于国家信息安全标准的专业信息安全检查服务，将传统的信息安全测评服务分解细化，可根据自身情况，选择不同的检查项和检查套餐",
            cc:"针对Web应用或网站的基于国家信息安全标准的专业信息安全检查服务，将传统的信息安全测评服务分解细化，可根据自身情况，选择不同的检查项和检查套餐",
			price:'在线咨询',
			url:require('../../assets/images/testing/5-1/187_G_1530772231890.jpg')
		}
	}
},
mounted(){

},
methods:{
	

}


};
</script>

<style type="text/css" lang="less" scoped>
.details{
	width:1200px;
	margin:0 auto;

//**/
.conten_body{
	margin-top:30px;
	overflow: hidden;
}
.conten_left{
	width:880px;
	float:left;
	background:#fff;
	box-sizing: border-box;
}
.nav_list{
	height:39px; 
   border-bottom: 1px solid #CFCDCD;
}
.nav_list li{
	float:left;
	width:120px;
	text-align:center;
}
.nav_list li a{
	display: inline-block;
	height:39px;
	font-size: 15px;
	line-height: 39px;
	color: #007CC6;
}
.nav_list li  .a_active{
   color:#007CC6;
   border-bottom:1px solid #007CC6;
}
.con_list{
	// padding:0 35px;
	overflow:hidden;
}
.con_list img{
	width:100%;
}





}


</style>







